import React from 'react';
import { withTranslation } from 'react-i18next';

import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const StyledTypography = styled(Typography)(({ theme }) => ({
	fontSize: '70px',
	letterSpacing: '-1px',
	fontWeight: '500',
	margin: '30px 0 0',
	color: theme.palette.primary.main
}));

const StyledSpan = styled('span')(({ theme }) => ({
	fontWeight: 600,
	color: theme.palette.secondary.main
}));

const Header = () => {
	return (
		<Box
			component='header'
			sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}
		>
			<StyledTypography component='h1'>
				Need <StyledSpan>Help?</StyledSpan>
			</StyledTypography>
		</Box>
	);
};

export default withTranslation('common')(Header);
